import React, { Component } from 'react';
import Vas from '../../../Vas';
//import '../css/CustomerCreateContract.css';
import { LinkButton } from 'component-lib';

class ContractEditStateSuccess extends Component
{

  constructor(props)
  {
    super(props);
    this.state = {};
    this.ContractId = props.match.params.ContractId;
    this.CustomerId = props.match.params.CustomerId;
    this.CustomerName = props.match.params.CustomerName;
  }
 
  render()
  {
    return (
      <div className={"form"}>
        <table >
          <thead>
            <tr>
              <th style={{fontSize:'large',width:'400px'}} colSpan={2}>
                {Vas.Resources.Labels["DeclineSuccess"]}
                
              </th>
            </tr>
          </thead>
        <tbody>
          <tr></tr>
          <tr>
            <td style={{paddingTop:'50px' }}>{Vas.Resources.Labels["LinkLoginPlural"]}</td>
              <td >
                <LinkButton 
                Text={Vas.Resources.Labels["ContractDetails"]} 
                Id={"LinkLogin"} 
                OnClick={()=>{
                  Vas.GetView("Contract", { Id: this.ContractId, CustomerId: this.CustomerId, CustomerName:this.CustomerName }, true);
                }}
              />
              </td>
          </tr>
        </tbody>
      </table>
      </div>
      
    );
  }
}
export default ContractEditStateSuccess;
